import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {
    estudianteId: 0,
    fullName: "",
    hayProcesoAbierto: false,
    bloqueos: [],
    estaSuspendido: false,
    id: "",
    saldoVencidoColones: 0,
    saldoVencidoDolares: 0,
    correoElectronico: "",
    nombres: "",
    apellidos: "",
    telefono: "",
    cedula: "",
  },
  isATeacher: false,
  isAdmin: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setIsATeacher: (state, action) => {
      state.isATeacher = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
  },
});

export const { setUserInfo, setIsATeacher, setIsAdmin } = userSlice.actions;

export default userSlice.reducer;
